const TRANSPARENT = new Set(['transparent', 'rgba(0, 0, 0, 0)']);

/** The first opaque background painted at or behind `element`, or undefined when none is. */
export function surfaceColor(element: HTMLElement): string | undefined {
  for (let node: HTMLElement | null = element; node; node = node.parentElement) {
    const color = getComputedStyle(node).backgroundColor;
    if (color && !TRANSPARENT.has(color)) {
      return color;
    }
  }
  return undefined;
}
